import {combineReducers} from 'redux';
import {actionDialogsReducer} from './actionDialogs';
import {chipsCountersReducer} from './chipsCounters';
import {managementReducer} from './management';
import {offersLunGeoDataReducer} from './offersGeo';

export const offersReducer = combineReducers({
  management: managementReducer,
  chipsCounters: chipsCountersReducer,
  dialogs: actionDialogsReducer,
  offerLunGeoData: offersLunGeoDataReducer
});
